module.exports = __webpack_public_path__ + "img/snosteinskredaktsomhet.5c5f6c7c.jpg";